// extracted by mini-css-extract-plugin
export default {"Layout":"Root_Layout__Jqwcj"};